<div class="module-icon menu-item" ng-class="$ctrl.iconClasses()" style="width:50px;height:50px;font-size:50%">
    <a ng-click="$ctrl.navigate()">
        <div class="nav-link" ng-bind-html="$ctrl.config.image"></div>
        <div class="navigation-text">{{$ctrl.config.text}}</div>
    </a>
</div>